import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9f715f8d: FaireBrandEntity = {
  token: "b_9f715f8d",
  type: "brand",
  name: "Casa Amarosa",
  avatarUrl:
    "https://cdn.faire.com/fastly/bd676dd5dfb0b8911161d6dbb351a8b6633ac28e54640ba9354f3332c0e1770a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bd676dd5dfb0b8911161d6dbb351a8b6633ac28e54640ba9354f3332c0e1770a.jpeg",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 175,
  isTopShop: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
